import Component from '../core/Component'
import { toggleClass } from '../utils/dom'

const STATES = {
    ACTIVE: 'is-active'
}

export default class ContactMap extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            bubble: null,
            map: null,
            countrys: [] // sorry english
        }

        this.ref.countries = this.ref.countrys
        delete this.ref.countrys

        this.canvas = {
            width: 0,
            height: 0
        }


        this.current
    }

    prepare() {
        const viewBox = this.ref.map.getAttribute('viewBox').split(' ').map(item => parseInt(item, 10))
        this.canvas = {
            width: viewBox[2],
            height: viewBox[3]
        }
        this.ref.countries.forEach(element => {
            element.addEventListener('mouseenter', this.handleCountryMouseenter)
            element.addEventListener('mouseleave', this.handleCountryMouseleave)
        })
    }

    destroy() {
        this.bubble = null
    }

    handleCountryMouseenter = event => {
        const box = event.target.getBBox()
        const canvasBox = this.ref.map.getBoundingClientRect()
        const scale = canvasBox.width / this.canvas.width

        if (!this.bubble) {
            this.bubble = Component.getFromElement(this.ref.bubble)
        }

        if (this.bubble) {
            this.bubble.update({
                x: (box.x + box.width/2) * scale,
                y: (box.y + box.height/2) * scale,
                code: event.target.dataset.code
            })
        }
    }

    handleCountryMouseleave = event => {
        this.bubble && this.bubble.hide()
    }
}



// WEBPACK FOOTER //
// ./components/ContactMap.js